import { createCipheriv, createDecipheriv, createHash, randomBytes } from "node:crypto";

const VERSION = "v1";
const IV_LENGTH = 12;
const AUTH_TAG_LENGTH = 16;

function aesKey(masterKey: string): Buffer {
	return createHash("sha256").update(masterKey, "utf8").digest();
}

export function sealBillingWebhookSecret(
	secret: string,
	masterKey: string,
): string {
	const key = aesKey(masterKey);
	const iv = randomBytes(IV_LENGTH);
	const cipher = createCipheriv("aes-256-gcm", key, iv);
	const encrypted = Buffer.concat([
		cipher.update(secret, "utf8"),
		cipher.final(),
	]);
	const tag = cipher.getAuthTag();
	return `${VERSION}.${iv.toString("base64url")}.${encrypted.toString("base64url")}.${tag.toString("base64url")}`;
}

export function openBillingWebhookSecret(
	ciphertext: string,
	masterKey: string,
): string {
	const parts = ciphertext.split(".");
	if (parts.length !== 4 || parts[0] !== VERSION) {
		throw new Error("Unsupported billing webhook secret envelope.");
	}
	const ivPart = parts[1];
	const dataPart = parts[2];
	const tagPart = parts[3];
	if (ivPart == null || dataPart == null || tagPart == null) {
		throw new Error("Unsupported billing webhook secret envelope.");
	}
	const iv = Buffer.from(ivPart, "base64url");
	const data = Buffer.from(dataPart, "base64url");
	const tag = Buffer.from(tagPart, "base64url");
	if (iv.length !== IV_LENGTH || tag.length !== AUTH_TAG_LENGTH) {
		throw new Error("Invalid billing webhook secret envelope.");
	}
	const key = aesKey(masterKey);
	const decipher = createDecipheriv("aes-256-gcm", key, iv);
	decipher.setAuthTag(tag);
	return Buffer.concat([decipher.update(data), decipher.final()]).toString(
		"utf8",
	);
}
